import React, { Component } from "react";
import { Navbar, Nav, NavItem, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { customLog } from "../../variables/Variables";

//CSS
import "assets/css/egeetouch.min.css";
import "../../assets/css/maincss.css";

// Firebase
import { doSignout } from "../../firebase/index";
// import withAuthorization from "../../components/Authorization/withAuthorization";
import { fire, auth } from "../../firebase/index";
// Routes
import "routes/app.jsx";
// Authentication
import AuthUserContext from "../Auth/AuthUserContext";

// Icons
import SettingsIcon from "../../assets/img/Settings.png";
import SettingsIconActive from "../../assets/img/SettingsActive.png";
import Loading from "../Loading/Loading";
// import { auth } from 'firebase';
// import changeLanguageGlobal from "../../variables/Variables";
//import language global changer in variable
import LocalizedStrings from "react-localization";
import { ModalBody } from "reactstrap";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    intelligentAccessManagementSystem: "Intelligent Access Management System",
    IAMSystem: "IAM System",
    JAP: "JAP",
    ENG: "ENG",
    SPA: "SPA",
    logout: "Logout",
    confirmLogout1: "Are you sure you want to log out of ",
    confirmLogout2: " ?",
    cancel: "Cancel",
    logoutHeader: "Logout Confirmation",
  },
  ja: {
    intelligentAccessManagementSystem: "インテリジェントアクセス管理システム（IAM）",
    IAMSystem: "IAMシステム",
    JAP: "日本語",
    ENG: "英語",
    SPA: "スペ語",
    logout: "ログアウト",
    confirmLogout1: "",
    confirmLogout2: " からログアウトしてもよろしいですか？",
    cancel: "キャンセル",
    logoutHeader: "ログアウトの確認",
  },
  es: {
    intelligentAccessManagementSystem: "Sistema de Gestión de Acceso Inteligente（IAM）",
    IAMSystem: "Sistema IAM",
    JAP: "Japonés",
    ENG: "Inglés",
    SPA: "Español",
    logout: "Cerrar sesión",
    confirmLogout1: "¿Está seguro de que desea cerrar sesión en ",
    confirmLogout2: "?",
    cancel: "Cancelar",
    logoutHeader: "Confirmación de cierre de sesión",
  },
});

//Inline CSS
//TopRight Corner
//Nav
// const pStyle = {
//   margin: "0px",
//   display: "block",
//   position: "relative",
//   top: "15px"
// };

// // container for the top right corner (logoutbtn and welcome,Username)
// const cornerContainerStyle = {
//   position: "relative",
//   top: "5px"
// };

// // LogoutBtn Color
// const logoutbtnStyle = {
//   color: "#333333"
// };

// // Logonuser Color
// const userStyle = {
//   color: "#333333"
// };

// // namedisplay
// const pNameStyle = {
//   position: "relative",
//   top: "-10px",
//   right: "-100px"
// };

// const authCondition = authUser => !!authUser;
export const HeaderLinks = () => (
  <AuthUserContext.Consumer>
    {authUser => (authUser ? <HeaderAuth /> : <HeaderNonAuth />)}
  </AuthUserContext.Consumer>
);

const HeaderAuth = () => {
  return <div></div>;
};

const HeaderNonAuth = () => {
  return (
    <div>
      <Nav />
      {/* <Nav pullRight /> */}
    </div>
  );
};
// const custHeader = {
//   backgroundColor: "#FFA617" // orange
// };

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPaymentValid: false,
      isAdmin: false,
      isSuperAdmin: false,
      sidebarExists: false,
      userName: [],
      currentLanguage: localizationStrings.getLanguage(),
      currentUserUID: "",
      loading: true,
      pageLoaded: false, // new state variable
      isNavBarReady: false,

      SettingsIcon: SettingsIcon,

      showPopup: false,
    };
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.greetingsAndLogout = this.greetingsAndLogout.bind(this);
    this.switchLanguage = this.switchLanguage.bind(this);
    this.switchLanguageTest = this.switchLanguageTest.bind(this);
    // this.namedisplay = this.namedisplay.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.confirmLogout = this.confirmLogout.bind(this);
  }

  componentDidMount() {
    // Set a timeout to mark the page as loaded after 1 second
    setTimeout(() => {
      this.setState({ pageLoaded: true });
    }, 3500);
  }

  onNavBarReady = () => {
    this.setState({ isNavBarReady: true });
  };

  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }

  componentWillMount() {
    this._authUnsub = auth.onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        this.setState({
          currentUserUID: user.uid,
          loading: false
        });

        fire
          .database()
          .ref("userSettings")
          .child(user.uid)
          .child("language")
          .on("value", this._langCb = snapshot => {
            customLog(snapshot.val());
            if (snapshot.val() === null) {
              fire
                .database()
                .ref("userSettings")
                .child(user.uid)
                .child("language")
                .set("en");

              this.setState({
                currentLanguage: localizationStrings.getLanguage()
              });
              customLog(this.state.currentLanguage);
            } else {
              this.setState({
                currentLanguage: snapshot.val()
              });
            }
          });
      } else {
        // No user is signed in.
        customLog("Not Signed In");
      }
    });
    // const groupAccountsDB = fire.database().ref("groupAccounts");

    //   groupAccountsDB.once("value").then(snapshot => {
    //     if (snapshot.exists()) {
    //       snapshot.forEach(eachSuperAdmin => {
    //         const superAdminDetails = eachSuperAdmin.val();
    //         // const superAdminId = eachSuperAdmin.key;
    //         const members = superAdminDetails.members;
    //         for (const eachMembers in members) {
    //           const memberDetails = members[eachMembers];
    //           if (memberDetails.memberEmail === auth.currentUser.email) {
    //             const paymentDetails = superAdminDetails.payment.isPaymentValid;
    //             this.setState({
    //               isAdmin: memberDetails.isAdmin,
    //               isSuperAdmin: memberDetails.isSuperAdmin,
    //               isPaymentValid: paymentDetails
    //             });
    //           }
    //         }
    //       });
    //       this.render()
    //       customLog("Current user is admin ".isAdmin)
    //       customLog("Current user is super ".isSuperAdmin)
    //       customLog("Current user is payment ".isPaymentValid)
    //       // this.setState({ isPaymentValid: snapshotVal.isPaymentValid });
    //     }
    //   });
    // if (auth.currentUser !== null) {
    //   this.setState({
    //     userName: auth.currentUser.email,
    //     loading: false,
    //   })
    // } else {
    //   this.setState({
    //     userName: null,
    //     loading: false,
    //   })
    // }

    // fire
    //   .database()
    //   .ref("registeredIndustrialUsersOnPlatform")
    //   .child(auth.currentUser.uid)
    //   .once("value")
    //   .then(async snapshot => {
    //     if (snapshot.exists()) {
    //       this.setState({
    //         userName: auth.currentUser.email,
    //         loading: false
    //       });
    //       // try {
    //       //   await this.setState({
    //       //     userName: auth.currentUser.email,
    //       //     loading: false
    //       //   });
    //       // } catch (error) {
    //       //   customLog(error.message);
    //       // }
    //     } else {
    //       this.setState({ userName: null });
    //     }
    //   });

    // .then(() => {
    //   customLog(this.state.userName)
    // });
  }

  namedisplay() {
    if (this.state.loading) {
      return "";
    } else {
      if (auth.currentUser !== null) {
        return <em className="userStyle">{auth.currentUser.email}</em>;
      }
    }
  }

  greetingsAndLogout() {
    return (
      <AuthUserContext.Consumer>
        {authUser => {
          if (authUser) {
            return (
              <div className={this.state.currentLanguage === "en" ? "top-header-right cornerContainerStyle cornerContainerStyleEN" : this.state.currentLanguage === "ja" ? "top-header-right cornerContainerStyle cornerContainerStyleJA" : this.state.currentLanguage === "es" ? "top-header-right cornerContainerStyle cornerContainerStyleES" : "top-header-right cornerContainerStyle"}>
                {/* <div id="nameDisplay" className="pNameStyle">
                  {this.namedisplay()}
                </div> */}

                <div className="switchLanguageWrapper ">
                  <select
                    id="switchLanguageDropdown"
                    name="switchLanguageDropdown"
                    onChange={this.switchLanguage}
                    value={this.state.currentLanguage}
                  >
                    <option value="en">English</option>
                    <option value="ja">日本語</option>
                    {/* <option value="es">Español</option> */}
                  </select>
                  {/* <button
                    className="switchLanguageBtn"
                    onClick={this.switchLanguage}
                  >
                    {this.state.currentLanguage === "en"
                      ? localizationStrings.ENG
                      : this.state.currentLanguage === "ja"
                        ? localizationStrings.JAP
                        : localizationStrings.SPA}
                  </button> */}
                </div>
                <Nav>
                  <LinkContainer id="ahrefToSetting" to="/setting">
                    <NavItem>
                      <button className="HeaderSettingNav">
                        <img
                          style={{
                            display: "block",
                            marginRight: "10px",
                            height: "50px",
                            width: "50px",
                            padding: "2px 2px",
                          }}
                          onMouseOver={() =>
                            this.setState({ SettingsIcon: SettingsIconActive })
                          }
                          onMouseOut={() =>
                            this.setState({ SettingsIcon: SettingsIcon })
                          }
                          src={this.state.SettingsIcon}
                          alt="SettingsIcon"
                        />
                      </button>
                    </NavItem>
                  </LinkContainer>
                </Nav>
                <div className="pStyle">
                  {/* <Nav>
                    <LinkContainer
                      id="ahrefToLogin"
                      to="/login"
                      onClick={doSignout}
                    >
                      <NavItem> */}
                        {/* <i
                          className="fa fa-sign-out logoutbtnStyle"
                          // style={logoutbtnStyle}
                        ></i> */}
                        {/* <b
                          id="logoutBtn"
                          className="logoutbtnStyle"
                          // style={logoutbtnStyle}
                        >
                          {" "}
                          Log out
                        </b> */}
                        {/* <button className="logoutbtnStyle" id="logoutBtn">
                          {localizationStrings.logout} {this.namedisplay()}
                        </button>
                      </NavItem>
                    </LinkContainer>
                  </Nav> */}
                  {/* <button className="logoutbtnStyle" id="logoutBtn" onClick={this.handlePopupOpen} style={{ display: "inline-flex", alignItems: "center" }}>
                    <span style={{ whiteSpace: "nowrap" }}>{localizationStrings.logout}</span><span style={{ maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", marginLeft: "5px" }}>{this.namedisplay()}</span>
                  </button> */}
                  <button className="logoutbtnStyle" id="logoutBtn" onClick={this.handlePopupOpen} style={{ display: "inline-flex", alignItems: "center" }}>
                    <span style={{ maxWidth: "250px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block" }}>{localizationStrings.logout} {this.namedisplay()}</span>
                  </button>
                </div>
              </div>
            );
          }
          // else {
          //  return (
          //    <div className="top-header-right cornerContainerStyle">
          //      <div className="switchLanguageWrapper">
          //        <button
          //          className="switchLanguageBtn"
          //          onClick={this.switchLanguage}
          //        >
          //          {/* {this.state.currentLanguage === "en" ? "ENG" : "JAP"} */}
          //          {this.state.currentLanguage === "en"
          //            ? localizationStrings.ENG
          //            : localizationStrings.JAP}
          //        </button>
          //      </div>
          //    </div>
          //  );
          //}
        }}
      </AuthUserContext.Consumer>
    );
  }

  switchLanguage(event) {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .set(event.target.value);
    }
  }

  // switchLanguage() {
  //   customLog(this.state.currentLanguage);
  //   if (auth.currentUser !== null) {
  //     fire
  //       .database()
  //       .ref("userSettings")
  //       .child(auth.currentUser.uid)
  //       .child("language")
  //       .once("value")
  //       .then(snapshot => {
  //         // let currentLanguage = snapshot.val()
  //         let settingRegistry = fire
  //           .database()
  //           .ref("userSettings")
  //           .child(auth.currentUser.uid);
  //         let currentLanguage = snapshot.val();
  //         if (currentLanguage === "en") {
  //           settingRegistry.child("language").set("ja");
  //           localizationStrings.setLanguage("ja");
  //           this.setState({ currentLanguage: "ja" });
  //         } else if (currentLanguage === "ja") {
  //           settingRegistry.child("language").set("es");
  //           localizationStrings.setLanguage("es");
  //           this.setState({ currentLanguage: "es" });
  //         } else if (currentLanguage === "es") {
  //           settingRegistry.child("language").set("en");
  //           localizationStrings.setLanguage("en");
  //           this.setState({ currentLanguage: "en" });
  //         } else {
  //           if (this.state.currentLanguage === "en") {
  //             settingRegistry.child("language").set("ja");
  //             localizationStrings.setLanguage("ja");
  //             this.setState({ currentLanguage: "ja" });
  //           } else {
  //             settingRegistry.child("language").set("en");
  //             localizationStrings.setLanguage(
  //               localizationStrings.getLanguage()
  //             );
  //             this.setState({
  //               currentLanguage: localizationStrings.getLanguage()
  //             });
  //           }
  //         }
  //       });
  //   }
  // }

  switchLanguageTest() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("ja");
      this.setState({ currentLanguage: "ja" }, () => {
        customLog(this.state.currentLanguage);
      });
    } else {
      customLog("STUPID");
      localizationStrings.setLanguage("en");
      this.setState({ currentLanguage: "en" }, () => {
        customLog(this.state.currentLanguage);
      });
    }
  }

  handlePopupOpen() {
    this.setState({ showPopup: true });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  confirmLogout = () => {
    this.handlePopupClose();
    doSignout();
  };

  componentWillUnmount() {
    if (this._authUnsub) this._authUnsub();
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { pageLoaded, isNavBarReady } = this.state;

    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <>
        {pageLoaded && (
          <div>
            <Modal dialogClassName="logout-modal" show={this.state.showPopup} onHide={this.handlePopupClose}>
              <Modal.Header style={{ backgroundColor: "orange", borderRadius: "5px 5px 0 0" }}>
                <p style={{ textAlign: "center", fontSize: "24px", color: "white", marginBottom: "0px" }}>{localizationStrings.logoutHeader}</p>
              </Modal.Header>
              <Modal.Body>
                <p style={{ textAlign: "center", fontSize: "18px", margin: "10px 0 25px" }}>{localizationStrings.confirmLogout1}{this.state.currentLanguage !== "ja" ? <br /> : ""}{this.namedisplay()}{this.state.currentLanguage === "ja" ? <br /> : ""}{localizationStrings.confirmLogout2}</p>
                <div className="modal-buttons" style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                  <button className="logout-confirm-btn" onClick={this.confirmLogout}>
                    {localizationStrings.logout}
                  </button>
                  <div style={{ width: "40px" }} />
                  <button className="logout-cancel-btn" onClick={this.handlePopupClose}>
                    {localizationStrings.cancel}
                  </button>
                </div>
              </Modal.Body>
            </Modal>
            <Navbar fluid className="top-header">
              <Navbar.Header>
                <Navbar.Toggle onClick={this.mobileSidebarToggle} />
              </Navbar.Header>
              <Navbar.Collapse>
                <div className="top-header__content">
                  <div className="top-header-left">
                    <h4>
                      <strong class="bigScreenTitle" style={{ whiteSpace: "nowrap" }}>
                        {localizationStrings.intelligentAccessManagementSystem}
                      </strong>
                      <strong class="smallScreenTitle">
                        {localizationStrings.IAMSystem}
                      </strong>
                    </h4>
                  </div>
                  {this.greetingsAndLogout()}
                </div>
              </Navbar.Collapse>
            </Navbar>
          </div>
        )}
        {!pageLoaded && (
          <>
            <div className="loading-screen">
              <style jsx>{`
                .loading-screen {
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: #f7f7f7;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  z-index: 9999;
                }
              `}</style>
              <div className="loading-spinner"></div>
              <Loading />
            </div>
          </>
        )}
      </>
    );
  }
}
// export default withAuthorization(authCondition)(Header);
export default Header;
